<template>
    <div class="container" v-if="detail!==null">
        <div class="first commonFirst">
            <div class="firstBox tc">
                今日晨检照片
            </div>
            <div class="relative">
                <img :src="detail.imageUrl" height="180" width="100%" alt="" v-if="detail.imageUrl">
                <van-image src="" height="180" width="100%" v-else />
                <div class="absolute flex">
                    <div>{{detail.className}}</div>
                    <div>{{detail.studentName}}</div>
                </div>
            </div>
        </div>
        <div class="second commonFirst">
             <div class="firstBox tc">
                今日晨检
            </div>
            <div class="secondBox">
                <div class="topCotent " :class="detail.temperature<=35.2?'gray':detail.temperature>=37.3?'red':''">   
                    <div class="flex flex-vc ">
                        <div class="zt first">
                           <img v-if="detail.temperature<=35.2"  src="@/assets/images/morningCheck/wdGray.png" width="14" height="31" alt="">
                           <img v-else-if="detail.temperature>35.2&&detail.temperature<=37.2" src="@/assets/images/morningCheck/wdj.png" width="14" height="31" alt="">
                           <img v-else src="@/assets/images/morningCheck/wdDanger.png" width="14" height="31" alt="">
                        </div>
                        <div class="wd">温度</div>
                    </div>
                    <div>{{detail.temperature}}℃</div>
                </div>
                <div v-for="(item,index) in statusList" class="flex dateBox flex-vc justify-content: space-around" :key="index">
                    <div class="flex-vc flex left">
                        <div class="zt">{{item.status===1?'':''}} 
                             <img v-if="item.status==0" width="24.29" height="23.24" src="@/assets/images/morningCheck/dzan.png" alt="">
                            <img v-else-if="item.status==1"  width="4.8px" height="24px" src="@/assets/images/morningCheck/gtDanger.png" alt="">
                            <img  v-else-if="item.status==2" width="4.8px" height="24px" src="@/assets/images/morningCheck/gtWarning.png" alt="">
                        </div>
                        <div>
                            <div :class="item.status===0||item.status===3?'default':item.status===1?'fail':'warning'">{{item.title}}</div>
                            <div class="small tc son desc" v-if="item.status==0||item.status===3"  >{{item.desc}}</div>
                            <!-- <div class="small tc mg-r th" v-else-if="item.status===1||item.status===2" :class="item.status===1?'fail':'warning'">{{item.desc}}</div> -->
                            <div class="small mg-r th" v-else :class="'fail'" >
                                <span v-for="(itemSon,indexSon) in item.desc" :class="item.status===1?'fail':'warning'" class="small tc fail" :key="indexSon"  >
                                    {{itemSon}} 
                                </span>
                                
                            </div>
                        </div>
                    </div>
                    <div class="rightIcon">
                        <van-image :src="item.img" width="72" height="51" v-if="item.img" @click="previewImg(item.img)">
                            <!-- <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                            </template> -->
                        </van-image>
                    </div>
                </div>
                <div class="zm">
                    <div :key="index" v-for="(item,index) in dateList" class="flex flex-dc flex-vc">
                        <div >
                            <img width="30px" height="31px" :src="item.status===0?dateStatus.ok:item.status===1?dateStatus.danger:dateStatus.default" alt="">
                        </div>
                        <div class="title tc">
                            {{item.weekName}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <div class="third commonFirst" v-if="phoneList.length>0">
             <div class="firstBox tc">
                家长联系方式
            </div>
            <div class="phoneOut flex flex-b flex-w mt-10 ">
                <div class="flex phoneBox mb-20" v-for="(item,index) in phoneList" :key="index">
                    <div class="parent">{{item.name+":"}}</div>
                    <div class="phone" v-if="item.isShowMobile" @click="callPhone(item.noMobile)">{{ item.noMobile }}</div>
                    <div class="phone" v-if="!item.isShowMobile">{{ item.mobile }}</div>

                    <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                        @click="getTeacherOrParentMobile(item, item.isShowMobile)"
                        v-if="!item.isShowMobile && item.name != '该学生未绑定家长'" name="eye-o" />
                    <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                        @click="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile"
                        name="closed-eye" />
                </div>
            </div>
        </div>
        <div></div>
    </div>
    <div v-else>
        <van-empty description="暂无数据" ></van-empty>
    </div>
</template>
<script>
import { ImagePreview } from 'vant'
import { reletionArr } from '@/utils/parent'
export default {
    data(){
        return{
            parentList:reletionArr,
            phoneList:[],
            detail:{
                img:"require('./gzh.jpg')"
            },
            dateStatus:{
                'ok':require('@/assets/images/morningCheck/boxGreen.png'),
                'default':require('@/assets/images/morningCheck/boxGrey.png'),
                'warning':require('@/assets/images/morningCheck/boxOrange.png'),
                'danger':require('@/assets/images/morningCheck/boxDanger.png'),
            },
            performanceStatus:{
                'ok':require('@/assets/images/morningCheck/dzan.png'),
                'default':require('@/assets/images/morningCheck/gtWarning.png'),
                'default':require('@/assets/images/morningCheck/gtDanger.png'),

            },
            dateList:[ 
            ],
            statusList:[
                {
                    status:"",
                    title:'口腔',
                    img:''
                },
                {
                    status:"",
                    title:'眼睛',
                    img:''
                },
                {
                    status:"",
                    title:'手部',
                    img:''
                },
                {
                    status:"",
                    title:'其他',
                    img:''
                },
            ],
            detail:''
        }
    },
    created(){
        this.getRobotDetectById();
    },
    methods:{
        callPhone(val){
            window.location.href="tel://"+val
        },
         // 获取学生家长的完整手机号
         getTeacherOrParentMobile(data, bol) {
            let parentList = this.phoneList
            if (!data.noMobile) { // 没有手机号
                this.$https.getMobileById({
                    id: data.id
                }).then(res => {
                    if (res.code == 200) {
                        parentList.forEach(item => {
                            if (item.id == data.id) {
                                item.noMobile = res.data
                                item.isShowMobile = !bol
                            }
                        })
                        this.phoneList = parentList
                        console.log('phoneList',this.phoneList)

                    } else {
                        this.$toast(res.msg)
                    }
                })
            } else { // 有手机号
                parentList.forEach(item => {
                    if (item.id == data.id) {
                        item.isShowMobile = !bol
                    }
                })
                this.phoneList = parentList
                console.log('phoneList',this.phoneList)

            }
        },
        previewImg(imgurl) {
            if(!imgurl) return
            ImagePreview({
                images: [imgurl],
                closeOnPopstate: true,
            })
        },
        //查询当前所选id的晨检详情
        async getRobotDetectById(){
            let status={0:'正常',3:'超时'}
            // this.$route.query   "1233152339059851264"
            let {code,data}=await this.$https.getRobotDetectById({id:this.$route.query.id});
            if(code==200){
                // console.log('我是获取到的data');
                // console.log(data);
                this.detail=data;
                if(!data) return;
                this.statusList[0]={
                    desc:this.clContent(data.mouth.status,data.mouth.symptoms),
                    status:data.mouth.status,
                    title:'口腔',
                    img:data.mouthImageUrl
                }
                this.statusList[1]={
                    desc:this.clContent(data.eye.status,data.eye.symptoms),
                    status:data.eye.status,
                    title:'眼睛',
                    img:data.eyeImageUrl
                }
                this.statusList[2]={
                    desc:this.clContent(data.hand.status,data.hand.symptoms),
                    status:data.hand.status,
                    title:'手部',
                    img:data.handImageUrl
                }
                this.statusList[3]={
                    desc:this.clContent(data.other.status,data.other.symptoms),
                    status:data.other.status,
                    title:'其他',
                    img:data.otherImageUrl
                }
                 this.dateList=data.weeks
                 if(data.parents.length<1) return;
                 data.parents && data.parents.forEach(item => {
                    item.isShowMobile = false
                })
                 this.phoneList=data.parents;
                 data.parents.forEach((val,index)=>{
                     this.phoneList[index].name=this.filterParent(val.relation)
                 })
            }
        },
        filterParent(val){
            // console.log(val);
            let zhi=this.parentList.find((valSon)=>{
                return val===valSon.id;
            })
            // console.log(zhi.name);
            return zhi.name;
        },
        //方法处理
        clContent(val,list){
            let status={0:'正常',3:'超时',1:list,2:list}
            return status[val];
        }
    }
}
</script>
<style lang="scss" scoped>
    .container{
        background: #F9F9F9;
         padding:0 10px;
        .firstBox{
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 39px;
            color: #FCFCFF; 
            opacity: 1; 
            height: 39px;
            background: #AAB4FC;
            opacity: 1;
            border-radius: 9px 0px 20px 0px;
        }
        .commonFirst{
            padding-bottom:26px;
        }
         .first{
            .firstBox{ 
                width: 117px;
              
            }
            .relative{
                 padding:0 23px;
                margin-top: 11px;
                .absolute{
                    left:30px;
                    bottom:10px;
                    color: #ffffff;
                    font-size: 14px;
                    div:nth-of-type(1){
                        margin: 0 10px 0 0;
                    }

                }
            }
         }
         .second{
             .wd{
                 font-size: 18px;
                 color:#ffffff;
                 font-weight: bold;
                 margin-left: 23px;
             }
             .zt.first{
                background: #C8F3EA;
                border:0;
             }
             .zt{
                width: 3.375rem;
                height: 3.375rem;
                border: 1px solid #E2E2E2;
                border-radius: 50%;
                 line-height: 50px;
                text-align: center;
                vertical-align: middle;
                img{
                vertical-align: middle;
                 
                   
                }
            }
             .firstBox{
                 width: 85px;
             }
             .secondBox{
                 padding:0 23px;
                 >div:nth-of-type(1){
                     background: #1BCFA2;
                     margin-top: 5px;
                 }
                 >div:nth-of-type(1).red{
                    background: #E40000;
                 }
                 >div:nth-of-type(1).gray{
                     background: #D6D6D6;
                 }
                
                 >div{ 
                     .default{
                         color:#2C3248;
                     }
                     .fail{
                        color:#DC0000;
                     }
                     .warning{
                         color:#F98A39;
                     }
                     .small{
                         font-size:12px;
                         width:100px;
                         margin-top:5px;
                     }
                     .small.son{
                         width:auto;
                     }
                     .desc{
                        color:#7E91B1;
                     }
                     padding:19px 16px;
                     margin-top: 18px;
                    height: 88px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
                    opacity: 1;
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    >.left:nth-of-type(1){
                        >div:nth-of-type(2){
                            margin-left: 23px;
                            font-size: 18px; 
                            font-weight: bold;
                            color: #ffffff;
                        }
                    }
                    >div:nth-of-type(2){
                        font-size:30px;
                        font-family:Microsoft YaHei;
                        font-weight:bold;
                        line-height:24px;
                        color: #FCFCFF;
                    }
                    .rightIcon{ 
                        width: 72px;
                        height: 51px; 
                        border-radius: 4px;
                        
                    }
                 }
             }
             .zm{
                box-shadow: none!important;
                opacity: 1;
                border-radius: 0px!important;
                 
                 >div{
                    
                     width:50px;
                     font-size: 14px!important;
                     font-weight: bold!important;
                     >div:nth-of-type(1){
                          margin-right: 0!important;
                        width:30px;
                        height:31px;
                        border-radius: 3px; 
                        
                     }
                    //  .warning{
                    //      background: #F98A38;
                    //  }
                    //  .default{
                    //      background:#2FD397;
                    //  }
                     .title{
                         margin-top:10px;
                         text-align: center;
                         color:#000000;
                     }
                 }
             }
         }
         >div{
            box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.09);
            opacity: 1;
            border-radius: 9px;
            background: #ffffff;
            margin:10px 0 0 0 ;
            img{
                border-radius: 9px;
            }
         }
        .third{
            margin-bottom: 30px;
            .firstBox{
                width: 117px;
            }
            .phoneOut{
                padding:0 23px;
                .phoneBox{
                    // width: 142px;
                    height: 19px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 19px;
                    color: #2440B3;
                    opacity: 1;
                    .parent{
                        color:#4D4D4D;

                    }
                }
            }
            
        }
    }
     

</style>